module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', [_c('canvas', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "the-canvas"
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "bar  bar-tab",
    style: ({
      'height': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [(_vm.pdfDoc && _vm.pageNum <= 1) ? _c('div', {
    staticClass: "foot",
    staticStyle: {
      "margin-left": "40%"
    }
  }, [(_vm.pageNum < _vm.pdfDoc.numPages) ? _c('button', {
    staticClass: "right",
    on: {
      "click": _vm.onNextPage
    }
  }, [_vm._v("下一页")]) : _vm._e()]) : _c('div', {
    staticClass: "foot",
    staticStyle: {
      "margin-left": "30%"
    }
  }, [(_vm.pageNum > 1) ? _c('button', {
    staticClass: "left",
    on: {
      "click": _vm.onPrevPage
    }
  }, [_vm._v("上一页")]) : _vm._e(), _vm._v(" "), (_vm.pageNum < _vm.pdfDoc.numPages) ? _c('button', {
    staticClass: "right",
    on: {
      "click": _vm.onNextPage
    }
  }, [_vm._v("下一页")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4187cf62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/finder/detail/PdfPreview.vue
// module id = 1615
// module chunks = 8